import { useEffect } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import './LogoutModal.scss';
import { removeToken } from '../../../../utils/authHelper';

interface LogoutModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onLogout: () => void;
}

function LogoutModal({open, setOpen, onLogout}:LogoutModalProps) {
  useEffect(()=>{
  }, [open])
    return <Modal
        open={open}
        onClose={() => setOpen(false)}
        className='logout-modal'
        centered={false}
        closeIcon
        size='mini'
    >
        <Modal.Header>Выйти из аккаунта</Modal.Header>
        <Modal.Content>
            Вы уверены, что хотите выйти из аккаунта?
        </Modal.Content>
        <Modal.Actions>
            <Button color='red' onClick={() => {
                removeToken();
                onLogout(); 
                setOpen(false);
            }}>Выйти</Button>
            <Button primary onClick={() => setOpen(false)}>Отмена</Button>
        </Modal.Actions>
    </Modal>
};

export default LogoutModal;